module.exports = __webpack_public_path__ + "static/electronics-be09a880f1141023f16f61bb3b80bb0a.svg";